"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useThemeMode = exports.initThemeMode = exports.setThemeMode = exports.getStoredThemeMode = void 0;
var react_1 = require("react");
var THEME_STORAGE_KEY = "rx-theme-mode";
var THEME_ATTRIBUTE = "data-theme";
// Dispatched on `document` (not a per-app event bus) because every
// microfrontend is script-injected into the same DOM/document - see
// TECH-1159 phase1.md. Each app's `useThemeMode()` listens for this to
// re-render with the matching precomputed theme object.
var THEME_CHANGE_EVENT = "rx-theme-change";
var prefersDark = function () {
    return typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-color-scheme: dark)").matches;
};
/** Stored user preference, if any - does not fall back to OS preference. */
var getStoredThemeMode = function () {
    if (typeof window === "undefined")
        return null;
    var stored = window.localStorage.getItem(THEME_STORAGE_KEY);
    return stored === "light" || stored === "dark" ? stored : null;
};
exports.getStoredThemeMode = getStoredThemeMode;
var readCurrentThemeMode = function () {
    if (typeof document === "undefined")
        return "light";
    return document.documentElement.getAttribute(THEME_ATTRIBUTE) === "dark"
        ? "dark"
        : "light";
};
var applyThemeMode = function (mode) {
    if (typeof document === "undefined")
        return;
    document.documentElement.setAttribute(THEME_ATTRIBUTE, mode);
};
/**
 * Sets the theme mode, persists it, and notifies every mounted
 * microfrontend (via `useThemeMode()`) to re-render with the matching
 * theme object. Call from the shell's toggle control.
 */
var setThemeMode = function (mode) {
    if (typeof window !== "undefined") {
        window.localStorage.setItem(THEME_STORAGE_KEY, mode);
    }
    applyThemeMode(mode);
    if (typeof document !== "undefined") {
        document.dispatchEvent(new CustomEvent(THEME_CHANGE_EVENT, { detail: mode }));
    }
};
exports.setThemeMode = setThemeMode;
/**
 * Resolves the initial theme mode - stored preference > OS preference >
 * light - and applies it. Call once, as early as possible (before first
 * paint) in the shell app only; other microfrontends just use
 * `useThemeMode()`, since the shell has already set the attribute by the
 * time they mount.
 */
var initThemeMode = function () {
    var _a;
    var mode = (_a = (0, exports.getStoredThemeMode)()) !== null && _a !== void 0 ? _a : (prefersDark() ? "dark" : "light");
    applyThemeMode(mode);
    return mode;
};
exports.initThemeMode = initThemeMode;
/** Current theme mode, re-rendering whenever `setThemeMode` is called anywhere. */
var useThemeMode = function () {
    var _a = (0, react_1.useState)(readCurrentThemeMode), mode = _a[0], setMode = _a[1];
    (0, react_1.useEffect)(function () {
        var handleChange = function (event) {
            setMode(event.detail);
        };
        document.addEventListener(THEME_CHANGE_EVENT, handleChange);
        return function () { return document.removeEventListener(THEME_CHANGE_EVENT, handleChange); };
    }, []);
    return mode;
};
exports.useThemeMode = useThemeMode;
//# sourceMappingURL=themeMode.js.map